export const flexAlignCentre = () => ({
  display: "flex",
  alignItems: "center",
});

export const displayFlex = () => ({
  display: "flex",
});

export const flexAllCentre = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
export const justifyContentSpaceBetween = () => ({
  justifyContent: "space-between",
});